import { render, staticRenderFns } from "./OtProfitability.vue?vue&type=template&id=696b291c&"
import script from "./OtProfitability.vue?vue&type=script&lang=js&"
export * from "./OtProfitability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports